module.exports = __webpack_public_path__ + "static/media/component-12.ff3ffc0c.svg";